import React from 'react';
import Tooltip from "@mui/material/Tooltip";

const FormRowLabel = (props) => {

    const getClassName = () => {
        let className = '';

        className += props.errorMessage ? 'error ' : '';

        className += props.disabled ? 'disabled ' : '';

        className += props.className;

        return className;
    }

    return (
        <label
            htmlFor={props.name}
            className={`margin-bottom-half ${getClassName()}`}
            style={{marginBottom: '0.5rem'}
        }>
            {props.label}
            {props.required ? '*' : ''}
            {(props.tooltip && props.tooltip.length) &&
                <Tooltip title={props.tooltip}>
                    <a className="form-row-tooltip">
                        <i className="fa fa-info-circle"/>
                    </a>
                </Tooltip>
            }
            {(props.disabledTooltip && props.disabled) &&
                <Tooltip title={props.disabledTooltip}>
                    <a className="form-row-tooltip">
                        <i className="fa fa-warning"/>
                    </a>
                </Tooltip>
            }
        </label>
    );
}

FormRowLabel.defaultProps = {
    className: ''
}

export default FormRowLabel;
